import styled from 'styled-components';

export const StyledCircle = styled.span`
    height: 12px;
    width: 12px;
    background-color: ${props => (props.enabled ? 'green' : '#bbb')} ;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
`;
